import store from "../../store/store";

export const componentKey = "REPORTS_SLICE";

const { actions } = store.reducerManager.add({
  key: componentKey,
  addedReducers: {
    setInventoryReport: (state, action) => {
      state.inventoryReport = action.payload;
    },
    setIncidentReport: (state, action) => {
      state.incidentReport = action.payload;
    },
    setUsageReport: (state, action) => {
      state.usageReport = action.payload;
    },
    setDailyOrdersReport: (state, action) => {
      state.dailyOrdersReport = action.payload;
    },
    setEmsDailyReport: (state, action) => {
      state.emsDailyReport = action.payload;
    },
    setFacilityPatientHistoryReport: (state, action) => {
      state.facilityPatientHistoryReport = action.payload;
    },
    setIcdReport: (state, action) => {
      state.icdReport = action.payload;
    },
    setProviderPatientLog: (state, action) => {
      state.providerPatientLog = action.payload;
    },
  },
  initialReducerState: {
    inventoryReport: {},
    incidentReport: {},
    usageReport: {},
    dailyOrdersReport: {},
    emsDailyReport: {},
    facilityPatientHistoryReport: {},
    icdReport: {},
    providerPatientLog: {},
  },
});

export const {
  setInventoryReport,
  setIncidentReport,
  setUsageReport,
  setDailyOrdersReport,
  setEmsDailyReport,
  setFacilityPatientHistoryReport,
  setIcdReport,
  setProviderPatientLog,
} = actions;
